import { render, staticRenderFns } from "./RightNews.vue?vue&type=template&id=6b2667d7&scoped=true&"
import script from "./RightNews.vue?vue&type=script&lang=js&"
export * from "./RightNews.vue?vue&type=script&lang=js&"
import style0 from "./RightNews.vue?vue&type=style&index=0&id=6b2667d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2667d7",
  null
  
)

export default component.exports